import React, { useState, useEffect } from 'react';
import styles from './UserList.module.css';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../../components/common/DataTable';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';

const UserList = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);

  const size = 10;

  // 유저 패치
  const getUserList = async(page) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/v1/admin/users/list`, {
        params: { page, size }
      });

      const { items, pagination } = response.data.data;
      
      setUsers(items);
      setCurrentPage(pagination.currentPage);
      setTotalPages(
        pagination.hasNext ? pagination.currentPage + 1 : pagination.currentPage
      );
    } catch (error) {
      console.error("회원 목록 조회 중 오류: ", error);
    }
  };

  useEffect(() => {
    getUserList(1);
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  
  const handleSearch = () => {
    getUserList(1);
  };

  const handleRowClick = (user) => {
    navigate(`/users/${user.userId}`);
  };

  const columns = [
    {
      title: '순번',
      dataIndex: 'userId',
      width: '60px'
    },
    {
      title: '휴대폰 번호',
      dataIndex: 'phone',
      width: '150px'
    },
    {
      title: '이름',
      dataIndex: 'name',
      width: '100px'
    },
    {
      title: '가입 유형',
      dataIndex: 'provider',
      width: '120px'
    },
    {
      title: '활성화',
      dataIndex: 'status',
      width: '60px'
    },
    {
      title: '생성일',
      dataIndex: 'createdAt',
      width: '150px',
      render: (createdAt) => createdAt ? createdAt.replace('T', ' ').substring(0, 19) : ''
    },
    {
      title: '상세보기',
      dataIndex: 'userId',
      width: '100px',
      render: (userId) => (
        <button
          className={styles.detailButton}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/users/${userId}`);
          }}
        >
          상세보기
        </button>
      )
    }
  ];

  const SearchBox = () => {
    const [localValue, setLocalValue] = useState(searchKeyword);

    const handleInputChange = (e) => {
      setLocalValue(e.target.value);
    };

    // 휴대폰 검색 제출
    const handleFormSubmit = (e) => {
      e.preventDefault();
      setSearchKeyword(localValue);
      setCurrentPage(1);
    };

    return (
      <div className={styles.searchBox}>
        <form onSubmit={handleFormSubmit} className={styles.searchForm}>
          <input
            type="text"
            placeholder="휴대폰 번호로 조회"
            value={localValue}
            onChange={handleInputChange}
            className={styles.searchInput}
            autoComplete="off"
          />
          <button type="submit" className={styles.searchButton}>
            <span role="img" aria-label="search">🔍</span>
          </button>
        </form>
      </div>
    );
  };

  // 검색창이 입력이 한 글짜씩 밖에 안되어서 memo로 조치 취함
  const MemoizedSearchBox = React.memo(SearchBox);

  return (
    <div className={styles.container}>
      <DataTable
        columns={columns}
        data={users}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
        actionButton={<MemoizedSearchBox />}
      />
      {loading && <div className={styles.loadingOverlay}><span>로딩 중...</span></div>}
    </div>
  );
};

export default UserList;